// import image1 from "../../images/thumbnails/a.jpg";
// import image2 from "../../images/thumbnails/b.jpg";
// import image3 from "../../images/thumbnails/c.jpg";
// import image4 from "../../images/thumbnails/d.jpg";
// import image5 from "../../images/thumbnails/f.jpg";

// export const SliderData = [
//   {
//     image: "image1",
//     title: "Dino",
//     desc: "dla najmłodszych dzieci",
//   },
//   {
//     image: "image2",
//     title: "Alladyn",
//     desc: "dla najmłodszych dzieci",
//   },
//   {
//     image: "image3",
//     title: "Kubuś",
//     desc: "dla najmłodszych dzieci",
//   },
//   {
//     image: "image4",
//     title: "Miś",
//     desc: "dla najmłodszych dzieci",
//   },
//   {
//     image: "image5",
//     title: "Popcorn",
//     desc: "dla najmłodszych dzieci",
//   },
// ];

export const SliderData = [
  {
    image: "https://www.slodkolandia.cba.pl/img/22-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/33-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/11-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/222-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/44-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/d/11-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/d/22-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/d/33-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/d/333-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/d/55-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/w/11-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/w/22-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/w/33-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/w/44-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/w/55-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/p/11-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/p/22-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/p/33-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/p/44-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/p/55-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/f/55-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/f/66-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/f/77-.jpg",
  },
  {
    image: "https://www.slodkolandia.cba.pl/img/f/88-.jpg",
  },
];
